export default {
  HOME: 'home',
  PIECE: 'piece',
  // STUDY: 'study',
  ABOUT: 'about',
  LEGAL: 'legal',
  NOTFOUND: 'notfound'
}
